import React, { useState, useEffect } from "react";
import "./Signin.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFormValidation from "../hooks/useFormValidation";
import { submitLogin } from "../apis/api/SignupApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../hooks/Loading";
import Cookies from "js-cookie";
// import { io } from "socket.io-client"; 
import {UAParser} from "ua-parser-js";        


const validate = (formData) => {
  const errors = {};
  if (!formData.username) errors.username = "Username is required";
  if (!formData.password) errors.password = "Password is required";
  return errors; 
};

function Signin() {
  const initialState = { username: "", password: "" };
  const { formData, errors, handleChange, handleSubmit } = useFormValidation(
    initialState,
    validate
  );

  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Login_detail, loading } = useSelector((state) => state.authSlice);
 
 
  const onSubmit = async () => {
    try {
      const location = await getFullUserLocation();

     
      const GetDeviceInfo = await getDeviceInfo();
      
      const parser = new UAParser(GetDeviceInfo?.userAgent);
      const browser = parser.getBrowser();
      const os = parser.getOS();
      const Login_country = location?.country ?? "Unknown";
      const IPAddress = location?.ip  ?? "0.0.0.1";;
      const data = new FormData();

     

      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
  
      
      data.append("Login_From_country", Login_country);
      data.append("Login_IPAddress", IPAddress);
      data.append("Login_From_Browser", browser?.name);
      data.append("Login_platform", os?.name);
      data.append("login_country_code", location?.calling_code.includes("+") ? location?.calling_code.split("+")[1] : location?.calling_code);
      data.append("Login_alpha3", location?.country_code);
      
      const response = await dispatch(submitLogin(data));
  
      if (response.payload.status == "success") {
      
        // const Id = response.payload.otp_id;

        // const email = response.payload.email;
        // Cookies.set("otpId", Id, { expires: 1 });
        // let id= Cookies.get('otpId');
        // sessionStorage.setItem('otpemail', email);


        // localStorage.clear();
        // sessionStorage.clear();              
        // Cookies.remove('otpId');


        if(response.payload.Data.memberData.member_active_deactive==1){
          navigate("/");
          toast.error("Your Account is deactivated Please contact to Admin!");
        }else{
          const userJSON = JSON.stringify(response.payload.Data.Membership);
        const access = JSON.stringify(response.payload.access);
        
        const userId = response.payload.Data.memberData.member_id;
        const company_id = response.payload.Data.memberData.company_id;
        const registration_type = response.payload.Data.memberData.registration_type;
        const token = response.payload.token;
   
        sessionStorage.setItem("userid", userId);

        const status = response.payload.Data.memberData.member_status;
        const member_type = response.payload.Data.memberData.member_type;

        // const socket = io("https://clubnet.app", { path: "/dev_node/connection" });
        let senderUserId=userId;
        if (userId) {
          

              // socket.on('connect', () => {
              //   console.log('Connected to WebSocket server');
              //   socket.emit('memberOnline', { userId }); 
              //   socket.emit("registerUser", senderUserId);
              // });
        
              // socket.on('disconnect', () => {
              //   console.log('Disconnected from WebSocket server');
              // });
        
              // socket.on('message', (message) => {
              //   console.log('Message from server:', message);
              // });
        
              // return () => {
              //   socket.emit('memberOffline', { userId }); // Notify server that the member is offline
              //   socket.disconnect();
              // };
          }
        Cookies.set("token", token, { expires: 1 });
        Cookies.set("status", status, { expires: 1 });
        Cookies.set("userId", userId, { expires: 1 });
        Cookies.set("company_id", company_id, { expires: 1 });
        Cookies.set("sorce_type", registration_type, { expires: 1 });
        Cookies.set("userJSON", userJSON, { expires: 1 });
        Cookies.set("member_type", member_type, { expires: 1 });
        Cookies.set("access", access, { expires: 1 });
    

        if (status == 0) {
          navigate("/first_reset_password");
        } else {
          navigate("/home");
        }
        
        toast.success("Login Successful!");
        }
        
    
      }else if(response.payload.status === "error"){
        toast.error(response.payload.message);
         navigate("/");
      }
      
    } catch (error) {
      toast.error("Invalid credentials!");
      navigate("/");
      console.error(error);
    }
  };

  
  // async function getFullUserLocation() {
  //   try {
  //     const res = await fetch("https://ipwho.is/");
  //     const data = await res.json();
    
  //     return data;
  //   } catch (err) {
  //     console.error("IP Location Error", err);
  //     return null;
  //   }
  // }

  // async function getFullUserLocation() {
  //   const services = [
  //     async () => {
  //       const res = await fetch("https://ipwho.is/");
  //       const d = await res.json();
  //       return {
  //         ip: d.ip,
  //         country: d.country,
  //         country_code: d.country_code,
  //         calling_code: d.calling_code
  //       };
  //     },
  //     async () => {
  //       const res = await fetch("https://ipapi.co/json/");
  //       const d = await res.json();
  //       return {
  //         ip: d.ip,
  //         country: d.country_name,
  //         country_code: d.country_code,
  //         calling_code: d.country_calling_code
  //       };
  //     },
  //     async () => {
  //       const res = await fetch("https://api.iplocation.net/?ip=");
  //       const d = await res.json();
  //       return {
  //         ip: d.ip,
  //         country: d.country_name,
  //         country_code: d.country_code,
  //         calling_code: null
  //       };
  //     },
  //     async () => {
  //       const res = await fetch("https://api.db-ip.com/v2/free/self");
  //       const d = await res.json();
  //       return {
  //         ip: d.ipAddress,
  //         country: d.countryName,
  //         country_code: d.countryCode,
  //         calling_code: null
  //       };
  //     }
  //   ];
  
  //   for (let service of services) {
  //     try {
  //       const result = await service();
  //       if (result?.country && result?.ip) {
  //         return result;
  //       }
  //     } catch (e) {
  //       console.warn("Geo API failed, trying next...");
  //     }
  //   }
  
  //   return null;
  // }
  

  let geoPromise = null;

async function getFullUserLocation() {

  const CACHE_KEY = "user_geo_data";
  const CACHE_TIME_KEY = "user_geo_time";

  const now = Date.now();
  const cachedData = localStorage.getItem(CACHE_KEY);
  const cachedTime = parseInt(localStorage.getItem(CACHE_TIME_KEY));

  // ✅ 12 hour cache (safe parse)
  if (cachedData && cachedTime && (now - cachedTime < 12 * 60 * 60 * 1000)) {
    try {
      return JSON.parse(cachedData);
    } catch {
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem(CACHE_TIME_KEY);
    }
  }

  // ✅ If request already running
  if (geoPromise) {
    return geoPromise;
  }

  geoPromise = (async () => {

    const services = [
      () => fetch("https://ipwho.is/"),
      () => fetch("https://ipapi.co/json/"),
      () => fetch("https://api.iplocation.net/?ip="),
      () => fetch("https://api.db-ip.com/v2/free/self")
    ];

    for (let service of services) {
      try {
        const res = await service();

        if (!res.ok || res.status === 429) continue;

        const d = await res.json();

        const result = {
          ip: d?.ip || d?.ipAddress || "0.0.0.0",
          country: d?.country || d?.country_name || d?.countryName || "Unknown",
          country_code: d?.country_code || d?.countryCode || "",
          calling_code: d?.calling_code || d?.country_calling_code || ""
        };

        if (result.ip && result.country) {

          localStorage.setItem(CACHE_KEY, JSON.stringify(result));
          localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());

          geoPromise = null;
          return result;
        }

      } catch {
        continue;
      }
    }

    // ✅ Even if all APIs fail, return safe fallback
    const fallback = {
      ip: "0.0.0.0",
      country: "Unknown",
      country_code: "",
      calling_code: ""
    };

    geoPromise = null;
    return fallback;

  })();

  return geoPromise;
}

  async function getDeviceInfo() {
    return {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        vendor: navigator.vendor,
        language: navigator.language,
        screen: {
            width: window.screen.width,
            height: window.screen.height
        }
    };
};
 

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
 
  return (
    <>
      <Loading loading={loading} />
      <div className="container-fluid p-0">
        <div className="row g-0">
          <div className="col-xxl-3 col-lg-4 col-md-5">
            <div className="auth-full-page-content d-flex p-sm-5 p-4">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5  d-flex align-items-center justify-content-around">
                  <img src="FLlogo.png" alt="" height="50" />
                  </div>
                  <div className="auth-content my-auto">
                    <div className="text-center">
                      <h5 className="mb-0">Welcome Back !</h5>
                      <p className="text-muted mt-2">
                        Sign in to continue to Freight Lounge.
                      </p>
                    </div>
                    <form
                      className="mt-4 pt-2"
                      onSubmit={(e) => handleSubmit(e, onSubmit)}
                    >
                      <div className="mb-3">
                        <label className="form-label">Username</label>
                        <input
                          type="text"
                          name="username"
                          className="form-control fc-enter"
                          id="username"
                          placeholder="Enter username "
                          value={formData.username}
                          onChange={handleChange}
                        />
                        {errors.username && (
                          <span className="error-text">{errors.username}</span>
                        )}
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1">
                            <label className="form-label">Password</label>
                          </div>
                          <div className="flex-shrink-0">
                            <div>
                              <Link to="/forget" className="text-muted">
                                Forgot password?
                              </Link>
                            </div> 
                          </div>
                        </div>
                        <div className="input-group auth-pass-inputgroup">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className="form-control fc-enter"
                            id="password"
                            placeholder="Enter password"
                            value={formData.password}
                            onChange={handleChange}
                          />
                          <button
                            className="btn btn-light shadow-none password-toggle-button"
                            type="button"
                            id="password-addon"
                            onClick={togglePasswordVisibility}
                          >
                            <i
                              className={
                                showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                              }
                            ></i>
                          </button>
                        </div>
                        {errors.password && (
                          <span className="error-text">{errors.password}</span>
                        )}
                      </div>
                      <div className="row mb-4">
                        <div className="col">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="remember-check"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="remember-check"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>
                    </form>
                    <div className="mt-5 text-center">
                      <p className="text-muted mb-0">
                        Don't have an account?{" "}
                        <a href="https://select.freightlounge.network/prices-and-packages/" target="blank"> Signup now </a>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-9 col-lg-8 col-md-7 rt-col">
            <div className="auth-bg pt-md-5 p-4 d-flex">
              <div className="bg-overlay bg-primary1"></div>
              <ul className="bg-bubbles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              <div className="row justify-content-center align-items-center">
                <div className="col-xl-7">
                  <div className="p-0 p-sm-4 px-xl-0">
                    <div
                      id="reviewcarouselIndicators"
                      className="carousel slide"
                      data-bs-ride="carousel"
                    >
                      <div className="carousel-indicators carousel-indicators-rounded justify-content-start ms-0 mb-0">
                        <button
                          type="button"
                          data-bs-target="#reviewcarouselIndicators"
                          data-bs-slide-to="0"
                          className="active"
                          aria-current="true"
                          aria-label="Slide 1"
                        ></button>
                        <button
                          type="button"
                          data-bs-target="#reviewcarouselIndicators"
                          data-bs-slide-to="1"
                          aria-label="Slide 2"
                        ></button>
                        <button
                          type="button"
                          data-bs-target="#reviewcarouselIndicators"
                          data-bs-slide-to="2"
                          aria-label="Slide 3"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center align-items-center">
                <div className="col-xl-7">
                  <div className="p-0 p-sm-4 px-xl-0">{/* Content Here */}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signin;
